export const BACKUP_TYPE_CREATE_RESET = 'BACKUP_TYPE_CREATE_RESET'
export const BACKUP_TYPE_CREATE_SET_CREATED = 'BACKUP_TYPE_CREATE_SET_CREATED'
export const BACKUP_TYPE_CREATE_SET_ERROR = 'BACKUP_TYPE_CREATE_SET_ERROR'
export const BACKUP_TYPE_CREATE_SET_VIOLATIONS = 'BACKUP_TYPE_CREATE_SET_VIOLATIONS'
export const BACKUP_TYPE_CREATE_TOGGLE_LOADING = 'BACKUP_TYPE_CREATE_TOGGLE_LOADING'
